var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "erpc-basic-settings p-b-15" }, [
    _c("div", { staticClass: "erpc-basic-settings__section-heading" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("PRIORITY_NEW_TARGETS_SLIDER_TITLE")) +
          "\n    "
      ),
      _c("i", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.right",
            value: _vm.$t("PRIORITY_NEW_TARGETS_SLIDER_TITLE_TT"),
            expression: "$t('PRIORITY_NEW_TARGETS_SLIDER_TITLE_TT')",
            modifiers: { right: true }
          }
        ],
        staticClass: "fa fa-question-circle m-l-5"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row m-b-15" }, [
      _c(
        "div",
        [
          _c("vue-slider", {
            staticClass: "vue-slider-v1 flex--grow",
            attrs: {
              tooltip: "none",
              height: 15,
              marks: _vm.newTargetPriorityMarks
            },
            scopedSlots: _vm._u([
              {
                key: "dot",
                fn: function() {
                  return [
                    _c("div", { staticClass: "vue-slider-dot-handle" }, [
                      _c("i", {
                        staticClass: "fa fa-ellipsis-v",
                        attrs: { "aria-hidden": "true" }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.erpcSettingBasic.newTargetPriority,
              callback: function($$v) {
                _vm.$set(_vm.erpcSettingBasic, "newTargetPriority", $$v)
              },
              expression: "erpcSettingBasic.newTargetPriority"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "erpc-basic-settings__section-heading" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("PRIORITY_UP_TARGETS_SLIDER_TITLE")) + "\n    "
      ),
      _c("i", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.right",
            value: _vm.$t("PRIORITY_UP_TARGETS_SLIDER_TITLE_TT"),
            expression: "$t('PRIORITY_UP_TARGETS_SLIDER_TITLE_TT')",
            modifiers: { right: true }
          }
        ],
        staticClass: "fa fa-question-circle m-l-5"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row m-b-15" }, [
      _c(
        "div",
        [
          _c("vue-slider", {
            staticClass: "vue-slider-v1 flex--grow",
            attrs: {
              tooltip: "none",
              height: 15,
              marks: _vm.underPerformingTargetPriorityMarks
            },
            scopedSlots: _vm._u([
              {
                key: "dot",
                fn: function() {
                  return [
                    _c("div", { staticClass: "vue-slider-dot-handle" }, [
                      _c("i", {
                        staticClass: "fa fa-ellipsis-v",
                        attrs: { "aria-hidden": "true" }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.erpcSettingBasic.underPerformingTargetPriority,
              callback: function($$v) {
                _vm.$set(
                  _vm.erpcSettingBasic,
                  "underPerformingTargetPriority",
                  $$v
                )
              },
              expression: "erpcSettingBasic.underPerformingTargetPriority"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "erpc-basic-settings__section-heading" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("STABILITY_SLIDER_TITLE")) + "\n    "),
      _c("i", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.right",
            value: _vm.$t("STABILITY_SLIDER_TITLE_TT"),
            expression: "$t('STABILITY_SLIDER_TITLE_TT')",
            modifiers: { right: true }
          }
        ],
        staticClass: "fa fa-question-circle m-l-5"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row m-b-15" }, [
      _c(
        "div",
        [
          _c("vue-slider", {
            staticClass: "vue-slider-v1 flex--grow",
            attrs: { tooltip: "none", height: 15, marks: _vm.stabilityMarks },
            scopedSlots: _vm._u([
              {
                key: "dot",
                fn: function() {
                  return [
                    _c("div", { staticClass: "vue-slider-dot-handle" }, [
                      _c("i", {
                        staticClass: "fa fa-ellipsis-v",
                        attrs: { "aria-hidden": "true" }
                      })
                    ])
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.erpcSettingBasic.stability,
              callback: function($$v) {
                _vm.$set(_vm.erpcSettingBasic, "stability", $$v)
              },
              expression: "erpcSettingBasic.stability"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }